// extracted by mini-css-extract-plugin
export var active = "header-module--active--c4736";
export var companyLogo = "header-module--companyLogo--faa57";
export var logo = "header-module--logo--089b7";
export var main_menu = "header-module--main_menu--5d524";
export var menuToggle = "header-module--menuToggle--360c7";